import styled from 'styled-components'

import Typography from '@material-ui/core/Typography'

import InputText from '@galo-monitor/web-components/InputText'

export const FuncionalityName = styled(Typography)`
  flex: 1;
  align-items: center;
  display: flex;
  margin-right: 10rem;
`

export const Content = styled.div`
  display: flex;
`

export const TextField = styled(InputText)`
  min-width: 300px;
`
